module.exports = __webpack_public_path__ + "img/cart-top-right-cookie.b0baa7fa.webp";